import { Box, styled } from "@mui/material";

export const StopButtonWrapper = styled(Box, { name: "StopButtonWrapper" })({
  paddingTop: "6px",
  paddingRight: "5px",
  paddingBottom: "6px",
  paddingLeft: "5px",
});
